import CreateAttributeList, { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { BusienssControlNames, GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import WebDesigner from "../WebDesigner";

export default class BusinessGiftCards extends WBComponent {

    constructor() {
        super();
        this.vagaroLink = "https://www.vagaro.com/merchants/settings/lookandfeel/designgiftcard";
        this.typename = wBComponentTypeNames.businessGiftCertificates;
        this.displayName = "Gift Cards";
        this.dropList = defaultDropList;
        this.editList = [componentAttributeTypes.multiLocation,componentAttributeTypes.alloWMultiLocalationBooking, "gc-radius", "gc-spacing", ...CreateAttributeList(true, false, true, true, false, true,false), attributeTypes.fontFamily, attributeTypes.fontSize];
        this.resizeType = ResizeableType.All;
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation, "gc-spacing", "gc-radius"];
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512" fill="currentColor"><path d="M353.5 68.8L318.7 128H320h72c22.1 0 40-17.9 40-40s-17.9-40-40-40h-2.2c-14.9 0-28.8 7.9-36.3 20.8zM288 197.5l-61.6 73.9c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L243.4 176H184 64c-8.8 0-16 7.2-16 16V320H528V192c0-8.8-7.2-16-16-16H392 332.6l53.9 64.6c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1L288 197.5zM48 384v64c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V384H48zM256 128h1.3L222.5 68.8C214.9 55.9 201.1 48 186.2 48H184c-22.1 0-40 17.9-40 40s17.9 40 40 40h72zm7.9-83.6l24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0H392c48.6 0 88 39.4 88 88c0 14.4-3.5 28-9.6 40H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h41.6C99.5 116 96 102.4 96 88c0-48.6 39.4-88 88-88h2.2c31.9 0 61.5 16.9 77.7 44.4z" /></svg>
    }

    GetComponentGlobalCSS(node: LayoutNode, isEditor?: boolean): string {
        return GetStyling(node);
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("gc-spacing", "Card Spacing", "", AttributeInputType.MeasurementField,
                [
                    { label: "Auto", value: "" },
                    { label: "S", value: "4px" },
                    { label: "M", value: "10px" },
                    { label: "L", value: "24px" }

                ], { min: 0, max: 50, step: 1, unit: "px" }),
            new AttributeDefinition("gc-radius", "Card Radius", "", AttributeInputType.MeasurementField,
                [
                    { label: "Auto", value: "" },
                    { label: "S", value: "4px" },
                    { label: "M", value: "10px" },
                    { label: "L", value: "24px" }

                ], { min: 0, max: 50, step: 1, unit: "px" }),
        ]
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {

        const atts = GetNodeDomAttributes("v-gift-certificates flex-column max-100 w-full vb-control scrollable", component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, componentAttributeTypes.layoutId, "1");
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);

        if (!isEditor) {

            return <BusinessPlaceHolder node={component} dataKey={BusienssControlNames.giftCertificates} layout={layout} classNames={atts.className} />
        }

        return (
            <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                <style>{GetStyling(component)}</style>
                <GenericBusinessControl key={component.id + bid} layout={layout} dataKey={BusienssControlNames.giftCertificates} node={component} userContext={siteData} bLocationId={bid} />
            </div>
        )
    }
}

function GetStyling(node: LayoutNode) {

    const spacing = getNodeComponentAttributeValue(node, "gc-spacing", "8px");
    // let parsed = parseInt(spacing.replace("px", ""));
    // let num = (isNaN(parsed)) ? 12 : parsed;

    let radius = getNodeComponentAttributeValue(node, "gc-radius", "6px");

    return `
    .gift-card{
      
        padding: ${spacing} !important;
        
        cursor: pointer;
    }

    .gift-card .inner-gift-card{
       
        transition: box-shadow .2s,transform .2s;
        border-radius: ${radius} !important;
        overflow:hidden;
        padding-bottom:60%;
      
    }
    .gift-card:hover .inner-gift-card{
        transform: translateY(-2px);
        box-shadow: 0 5px 10px -2px rgba(0,0,0,.5);
       
    }


    `
}